module.exports = __webpack_public_path__ + "img/instagram-dialog.c4d2dc19.svg";